import { render, staticRenderFns } from "./baogao.vue?vue&type=template&id=29d188f8&scoped=true"
import script from "./baogao.vue?vue&type=script&lang=js"
export * from "./baogao.vue?vue&type=script&lang=js"
import style0 from "./baogao.vue?vue&type=style&index=0&id=29d188f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d188f8",
  null
  
)

export default component.exports